import {POST_AI_MARKUP_DATA, POST_AI_MARKUP_DATA_SUCCESS, POST_AI_MARKUP_DATA_FAIL, UPDATE_AI_MARKUP_DATA, GET_AI_MARKUP_DATA, 
    GET_AI_MARKUP_DATA_SUCCESS, GET_AI_MARKUP_DATA_FAIL} from './actionTypes'

const initialState = {
    loader: false,
    aiModalsuccessMessage: null,
    aiModalerrorMessage: null,
    aiModalData: null,
    aiModalDataError: null,
}

const getAImarkupReducer = (state = initialState, action) => {
    switch (action.type) {
        case POST_AI_MARKUP_DATA:
            state = {
                ...state,
                loader: true,
                aiModalsuccessMessage: null,
                aiModalerrorMessage: null
            }
            break
        case UPDATE_AI_MARKUP_DATA:
            state = {
                ...state,
                loader: false,
                successMessage: null,
                aiModalerrorMessage: null,
            }
            break
        case POST_AI_MARKUP_DATA_SUCCESS:
            state = {
                ...state,
                loader: false,
                aiModalsuccessMessage: action.payload,
                aiModalerrorMessage: null
            }
            break
        case POST_AI_MARKUP_DATA_FAIL:
            state = {
                ...state,
                loader: false,
                successMessage: null,
                aiModalerrorMessage: action.payload
            }
            break
        case GET_AI_MARKUP_DATA:
            state = {
                ...state,
                loader: true,
                aiModalData: null,
                aiModalDataError: null,
            }
            break
        case GET_AI_MARKUP_DATA_SUCCESS:
            state = {
                ...state,
                loader: false,
                aiModalData: action.payload,
                aiModalDataError: null
            }
            break
        case GET_AI_MARKUP_DATA_FAIL:
            state = {
                ...state,
                loader: false,
                aiModalData: null,
                aiModalDataError: action.payload
            }
            break
        default:
            state = { ...state }
            break
    }
    return state
}
export default getAImarkupReducer